var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternalIconButtom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.89 2 8 2.89 8 4V7C8 8.11 8.89 9 10 9H11V11H2V13H6V15H5C3.89 15 3 15.89 3 17V20C3 21.11 3.89 22 5 22H9C10.11 22 11 21.11 11 20V17C11 15.89 10.11 15 9 15H8V13H16V15H15C13.89 15 13 15.89 13 17V20C13 21.11 13.89 22 15 22H19C20.11 22 21 21.11 21 20V17C21 15.89 20.11 15 19 15H18V13H22V11H13V9H14C15.11 9 16 8.11 16 7V4C16 2.89 15.11 2 14 2H10ZM10 4H14V7H10V4ZM5 17H9V20H5V17ZM15 17H19V20H15V17Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalIconButtom);
export default __webpack_public_path__ + "static/media/Internal-icon-buttom.4ce58958e4edf449dc752339603ad9e4.svg";
export { ForwardRef as ReactComponent };